import { render } from "./VirologySectionDetails.vue?vue&type=template&id=24a7b3dc&scoped=true"
import script from "./VirologySectionDetails.vue?vue&type=script&lang=js"
export * from "./VirologySectionDetails.vue?vue&type=script&lang=js"

import "./VirologySectionDetails.vue?vue&type=style&index=0&id=24a7b3dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a7b3dc"],['__file',"src/components/VirologySectionDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24a7b3dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24a7b3dc', __exports__)) {
    api.reload('24a7b3dc', __exports__)
  }
  
  module.hot.accept("./VirologySectionDetails.vue?vue&type=template&id=24a7b3dc&scoped=true", () => {
    api.rerender('24a7b3dc', render)
  })

}


export default __exports__